import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/atoms/ui/dialog';
import { Input } from '@/components/atoms/ui/input';
import { Label } from '@/components/atoms/ui/label';
import { Button } from '@/components/atoms/ui/button';

interface UsernameRegistrationComponentProps {
  needsUsername: boolean;
  username: string;
  loading: boolean;
  error: string | null;
  authLoading: boolean;
  onUsernameChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export const UsernameRegistrationComponent: React.FC<UsernameRegistrationComponentProps> = ({
  needsUsername,
  username,
  loading,
  error,
  authLoading,
  onUsernameChange,
  onSubmit,
}) => {
  // Don't render until auth is initialized
  if (authLoading) {
    return null;
  }

  return (
    <Dialog open={needsUsername} onOpenChange={() => {}}>
      <DialogContent className="username-registration-component sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Choose your username</DialogTitle>
          <DialogDescription>
            Pick a unique username for your tuval.space account. This will be
            the name of your first board.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit}>
          <div className="grid gap-4 py-4">
            <div className="grid gap-2">
              <Label htmlFor="username">Username</Label>
              <Input
                id="username"
                placeholder="johndoe"
                value={username}
                onChange={(e) => {
                  onUsernameChange(e.target.value);
                }}
                disabled={loading}
                autoFocus
              />
              {error && <p className="text-sm text-destructive">{error}</p>}
              <p className="text-xs text-muted-foreground">
                3-20 characters, letters, numbers, hyphens, and underscores only
              </p>
            </div>
          </div>
          <DialogFooter>
            <Button type="submit" disabled={loading || !username}>
              {loading ? 'Creating...' : 'Create Account'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

